module.exports = "<div class=\"fc-container fc-container--<%=widgetType%> hide-on-childrens-books-site js-<%=widgetType%>\">\n    <div class=\"fc-container__inner js-<%=widgetType%>-container\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/common/views/commercial/external-content.html
// module id = 672
// module chunks = 1